import { isDemo } from '@dreryk/demo-variant-frontend';
import { useSessionState } from '@dreryk/egabinet-security-frontend';
import { TranslatableText, WithFieldController } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

const DEMO_EMAIL_PREFILL_VALUE = 'demo@dreryk.pl';

export type CurrentUserEmailFieldValue = null;

type CurrentUserEmailFieldProps = WithFieldController<unknown> & {
   readonly label: TranslatableText;
};

export const CurrentUserEmailField = (props: CurrentUserEmailFieldProps): JSX.Element => {
   const { account } = useSessionState();
   const defaultValue = isDemo() ? DEMO_EMAIL_PREFILL_VALUE : account?.login;

   return (
      <TextInput
         testId={'currentUserEmail'}
         label={props.label}
         controller={props.controller}
         defaultValue={defaultValue}
         disabled
      />
   );
};
